<section class="col-xs-12 col-sm-12 financial_titlesection">
    <div class="col-xs-12 col-sm-12 col-md-7 col-lg-8 no-padding">
        <div class="financial_header">Financial Dashboard</div>

    </div>
    <div class="col-xs-12 col-sm-12 col-md-5 col-lg-4 financial_dateheader">
        Current Season:<span> {{currentseason?.currentSeason}}</span>
    </div>
</section>
